import {
  updateCellValue,
  updateRowData,
} from "containers/Compensation/helpers/tableData.helper";

const initialState = {
  isSubmitting: false,
  canSubmitConfig: null,
  isGroupTabLoading: false,
  groupTabs: null,
  isColumnsLoading: true,
  columnsData: null,
  isRowsLoading: true,
  rowsData: null,
  columnFilters: null,
  errorWarningCounts: null,
  quotaCards: null,
};

const compensation = (state = initialState, action) => {
  switch (action.type) {
    case "TOGGLE_IS_GROUP_TAB_LOADING": {
      return {
        ...state,
        isGroupTabLoading: action.payload,
      };
    }
    case "SET_GROUP_TABS": {
      return {
        ...state,
        groupTabs: action.payload,
      };
    }
    case "TOGGLE_IS_COLUMNS_LOADING": {
      return {
        ...state,
        isColumnsLoading: action.payload,
      };
    }
    case "SET_COLUMNS_DATA": {
      return {
        ...state,
        columnsData: action.payload,
      };
    }
    case "TOGGLE_IS_ROWS_LOADING": {
      return {
        ...state,
        isRowsLoading: action.payload,
      };
    }
    case "SET_ROWS_DATA": {
      return {
        ...state,
        rowsData: action.payload,
      };
    }
    case "UPDATE_CELL_VALUE": {
      const { approverGroupId, page, rowId, columnKey, value } = action.payload;
      return {
        ...state,
        rowsData: updateCellValue(
          state.rowsData,
          approverGroupId,
          page,
          rowId,
          columnKey,
          value
        ),
      };
    }
    case "UPDATE_ROW_DATA": {
      const { approverGroupId, page, rowId, rowData } = action.payload;
      return {
        ...state,
        rowsData: updateRowData(
          state.rowsData,
          approverGroupId,
          page,
          rowId,
          rowData
        ),
      };
    }
    case "SET_CAN_SUBMIT_CONFIG": {
      return {
        ...state,
        canSubmitConfig: action.payload,
      };
    }
    case "UPDATE_SUBMIT_STATUS": {
      return {
        ...state,
        canSubmitConfig: {
          ...state.canSubmitConfig,
          submitted: action.payload,
        },
      };
    }
    case "TOGGLE_IS_SUBMITTING": {
      return {
        ...state,
        isSubmitting: action.payload,
      };
    }
    case "SET_COLUMN_FILTERS": {
      return {
        ...state,
        columnFilters: action.payload,
      };
    }
    case "SET_ERROR_WARNING_COUNTS": {
      return {
        ...state,
        errorWarningCounts: action.payload,
      };
    }
    case "SET_QUOTA_CARDS_DATA": {
      return {
        ...state,
        quotaCards: action.payload,
      };
    }
    default:
      return state;
  }
};

export default compensation;
